import { NgClass } from "@angular/common";
import { booleanAttribute, ChangeDetectionStrategy, Component, ElementRef, inject, input } from "@angular/core";

@Component({
  selector: "component-button-with-loading",
  templateUrl: "./button-with-loading.component.html",
  imports: [NgClass],
  host: {
    class: "d-block"
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonWithLoadingComponent {
  private _elementRef = inject(ElementRef);

  readonly isLoading = input.required({
    transform: booleanAttribute
  });
  readonly disabled = input(false, {
    transform: booleanAttribute
  });
  readonly cssClass = input.required<string>();

  constructor() {
    // Add a capture phase event listener to block clicks on disabled button
    this._elementRef.nativeElement.addEventListener(
      "click",
      (event: MouseEvent) => {
        if (this.disabled()) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
        }
      },
      true
    );
  }
}
